// @ts-nocheck
/*
 * Port of components/partials/dashboard/tts/SsmlScriptView.js (80 lines).
 * BYTE-IDENTICAL. Renders a segmented inline view of an SSML string:
 * text spans + tag pills coloured by SSML_TAG_TYPES (currency / date /
 * digits / time / telephone). Supports optional CSS line-clamp.
 */
import React from 'react';
import { parseSsmlSegments } from './ssmlHelpers';

const SsmlScriptView = ({ value, clamp = 0, style = {} }: any) => {
  const segments = parseSsmlSegments(value);

  if (!segments.length) {
    return <span style={{ opacity: 0.6 }}>-</span>;
  }

  const clampStyle: any = clamp
    ? {
        display: '-webkit-box',
        WebkitLineClamp: clamp,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }
    : {};

  return (
    <span style={{ lineHeight: 1.9, wordBreak: 'break-word', ...clampStyle, ...style }}>
      {segments.map((seg: any, idx: number) => {
        if (seg.kind === 'text') {
          return <React.Fragment key={idx}>{seg.text}</React.Fragment>;
        }

        const {
          label = seg.interpretAs,
          glyph = '',
          border = '#94a3b8',
          bg = '#f8fafc',
          fg = '#475569',
        } = seg.type || {};

        return (
          <span
            key={idx}
            title={`Read as ${label} (lang ${seg.lang}, rate ${seg.rate})`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4em',
              margin: '0 0.2em',
              padding: '0.1em 0.5em 0.1em 0.15em',
              border: `1.5px solid ${border}`,
              borderRadius: '8px',
              background: bg,
              color: fg,
              fontSize: '0.86em',
              verticalAlign: 'middle',
              whiteSpace: 'nowrap',
            }}
          >
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '5px',
                background: fg,
                color: '#fff',
                fontSize: '0.68em',
                fontWeight: 700,
                padding: '0.15em 0.5em',
              }}
            >
              {glyph}
            </span>
            <span style={{ fontWeight: 700 }}>{seg.text}</span>
            <span
              style={{
                fontSize: '0.62em',
                fontWeight: 700,
                letterSpacing: '0.04em',
                opacity: 0.85,
              }}
            >
              {String(label).toUpperCase()}
            </span>
          </span>
        );
      })}
    </span>
  );
};

export default SsmlScriptView;
